import type { RequestFn } from 'api/useApiRequest';

type NewUploadHubFile = {
  url: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  organisationLogoUrl?: string;
  backgroundColor?: string;
};

type UploadHubFile = NewUploadHubFile & {
  publicId: string;
};

export type UploadHubListItem = UploadHubFile & {
  id: string | number;
  createdAtUtc: string;
  addedByUserFullName: string;
};

export const uploadFiles = (
  request: RequestFn,
  { files, signal }: { files: FileList | File[]; signal?: AbortSignal }
) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  return request({
    method: 'post',
    pathname: '/api/user-upload/upload',
    data: formData,
    signal,
  });
};

export const addUploadHubItem = (
  request: RequestFn,
  {
    files,
    fileName,
    organisationLogo,
    color,
    signal,
  }: {
    files: FileList | File[];
    fileName?: string;
    organisationLogo?: string | null;
    color?: string;
    signal?: AbortSignal;
  }
) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  if (fileName) formData.append('displayName', fileName);
  if (organisationLogo) formData.append('organisationLogoUrl', organisationLogo);
  if (color) formData.append('backgroundColor', color);
  return request({
    method: 'post',
    pathname: '/api/upload-hub/add',
    data: formData,
    signal,
  });
};

export const fetchUploadHubList = (request: RequestFn, { signal }: { signal?: AbortSignal } = {}) =>
  request({
    method: 'get',
    pathname: '/api/upload-hub/list',
    signal,
  });

export const updateUploadHubItem = (
  request: RequestFn,
  {
    id,
    file,
    fileName,
    organisationLogo,
    color,
    signal,
  }: {
    id: string | number;
    file?: File;
    fileName?: string;
    organisationLogo?: string | null;
    color?: string;
    signal?: AbortSignal;
  }
) => {
  const formData = new FormData();
  formData.append('id', String(id));
  if (file) formData.append('file', file);
  if (fileName) formData.append('fileName', fileName);
  if (organisationLogo) formData.append('organisationLogoUrl', organisationLogo);
  if (color) formData.append('backgroundColor', color);
  return request({
    method: 'post',
    pathname: '/api/upload-hub/update',
    data: formData,
    signal,
  });
};

export const deleteUploadHubItem = (
  request: RequestFn,
  { id, signal }: { id: string | number; signal?: AbortSignal }
) =>
  request({
    method: 'delete',
    pathname: `/api/upload-hub/delete/${id}`,
    signal,
  });
